import { ORGANIZATION_AUTHENTICATION } from "../types";
import createAsyncActions from "../utilities/createAsyncActions";
export const {
  organizationAuthentication,
  organizationAuthenticationPending,
  organizationAuthenticationFulfilled,
  organizationAuthenticationRejected,
} = createAsyncActions(
  ORGANIZATION_AUTHENTICATION,
  "organizationAuthentication"
);



// WEBPACK FOOTER //
// ./src/actions/organizationAuthenticationActions.js